import $ from "/srv/www/c/carspecial.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function() {
    $('body').on( 'added_to_cart', function(){
        animateCSS(".cart-customlocation", "bounce", animateAgain);
    });

    function animateAgain() {
        setTimeout(function() {
            animateCSS(".cart-customlocation", "bounce");
        }, 100)
    }

    function animateCSS(element, animationName, callback) {
        const node = document.querySelector(element);
        node.classList.add("animated", animationName);

        function handleAnimationEnd() {
            node.classList.remove("animated", animationName);
            node.removeEventListener("animationend", handleAnimationEnd);

            if (typeof callback === "function") callback();
        }

        node.addEventListener("animationend", handleAnimationEnd);
    }

    $("a.woocommerce-terms-and-conditions-link").unbind("click");
    $("body").on('click', 'a.woocommerce-terms-and-conditions-link', function(event) {
        $(this).attr("target", "_blank");
        window.open($(this).attr("href"));

        return false;
    });



    function equalHeight(){

        var maxHeight = 0,
        items = $('.ms-pricing-td-equal');
        items.css('height', '');
        

        items.each(function () {
            maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight); 
        });

        items.height(maxHeight);
    }
    function equalHeightimage(){

        var maxHeight = 0,
        items = $('.ms_pricing_desktop .image');
        items.css('height', '');
        

        items.each(function () {
            maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight); 
        });

        items.height(maxHeight);
    }
    equalHeightimage();
    equalHeight();
    $(window).resize(function(){
         equalHeightimage();
        equalHeight();
    });

    /**
     * When Cart has been emptied we need to make sure that cart form and cart collaterals in /cart page are removed.
     *
     * @param {Event} e
     */
    function cartEmptied(e) {
        const cartForm = $('.cart-wrapper');
        if (cartForm.length > 0) {
            cartForm.remove();
            var url = window.location.origin;
            if( window.location.origin === 'https://www.carspecial.nl'){
                $( "<a class='button wc-backward return-to-shop' href='https://www.carspecial.nl/winkel/'> Terug naar winkel </a>" ).insertAfter( ".cart-empty.woocommerce-info" );
            }else if( window.location.origin === 'https://www.carspecial.co.uk') {
                $( "<a class='button wc-backward return-to-shop' href='https://www.carspecial.nl/winkel/'> Return to shop</a>" ).insertAfter( ".cart-empty.woocommerce-info" );
            }
            else {
                ///
            }

        }
    }
    $(document.body).on('wc_cart_emptied', cartEmptied);
});
